<div *ngIf="controlInfo as c" [formGroup]="parentFormGroup">
  <label for="simple-input-text-form-{{controlId}}" class="form-label">
    {{c.alias ?? c.name}}
    <span *ngIf="c.required" class="text-red-400">*</span>
    <small *ngIf="c.label" class="text-muted text-xs">{{c.label}}</small>
  </label>
  <div class="form-group">
    <input [formControlName]="c.name" class="form-group-input" [min]="c.minDate" [max]="c.maxDate" [matDatepicker]="picker" matInput>
    <div class="form-group-label">
      <button (click)="picker.open()" type="button" class="outline-none">
        <i class="fal fa-calendar"></i>
      </button>
    </div>
  </div>
  <mat-datepicker #picker></mat-datepicker>
</div>